export enum FEATURE_FLAGS {
    DBC_MOBILE_APP_NUDGE = 'dbc-mobile-app-nudge',
}
